module.exports = __webpack_public_path__ + "static/media/5e902f22-dc96-42db-9cea-596fd6e0128f.0e7d74f0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274145/5e902f22-dc96-42db-9cea-596fd6e0128f.woff
// module id = 1663
// module chunks = 2